import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';
import { stringify } from 'qs';

export async function getUsers(id) {
  try {
    const url = `${constants.endpoints.USERS}/users/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch users failed', error.message);
    throw error;
  }
}

export async function getUser(id) {
  try {
    const url = `${constants.endpoints.USERS}/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch user failed', error.message);
    throw error;
  }
}

export async function createUser(data) {
  try {
    const response = await getInstance().post(constants.endpoints.USERS, data);
    return response.data;
  } catch (error) {
    console.error('Create user failed', error.message);
    throw error;
  }
}

export async function updateUser(id, data) {
  try {
    const url = `${constants.endpoints.USERS}/${id}`;
    const response = await getInstance().put(url, data);
    return response.data;
  } catch (error) {
    console.error('Update user failed', error.message);
    throw error;
  }
}

export async function deleteUser(id) {
  try {
    const url = `${constants.endpoints.USERS}/${id}`;
    const response = await getInstance().delete(url);
    return response.data;
  } catch (error) {
    console.error('Delete user failed', error.message);
    throw error;
  }
}

export async function deleteUsers(ids) {
  try {
    const response = await getInstance().delete(constants.endpoints.USERS, {
      params: { ids },
      paramsSerializer: {
        serialize: params => stringify(params, { arrayFormat: 'repeat' })
      }
    });
    return response.data;
  } catch (error) {
    console.error('Delete users failed', error.message);
    throw error;
  }
}

export async function updatePassword(password) {
  try {
    const response = await getInstance().post(constants.endpoints.USERS_UPDATE_PASSOWORD, {
      password
    });
    return response.data;
  } catch (error) {
    console.error('Update password failed', error.message);
    throw error;
  }
}

export async function getUserLocations(id) {
  try {
    const url = `${constants.endpoints.USERS}/locations/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch locations failed', error.message);
    throw error;
  }
}